<template>
  <div class="content">
    <div class="top">
      <div class="top-title flex">
        互斥设置<span class="color"
          >【线下消费，在线商城，计次商城】优惠不同享（至少勾选2种）</span
        >
      </div>
      <el-checkbox-group v-model="offline_buy" class="flex">
        <el-checkbox label="0">储值</el-checkbox>
        <el-checkbox label="1">积分</el-checkbox>
        <el-checkbox label="2">优惠券</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="top" style="margin-top: 10px">
      <div class="top-title flex">
        互斥设置<span class="color"
          >【自助买单、加油】优惠不同享（至少勾选2种）</span
        >
      </div>
      <el-checkbox-group v-model="offline_buy" class="flex">
        <el-checkbox label="0">储值</el-checkbox>
        <el-checkbox label="1">积分</el-checkbox>
        <el-checkbox label="2">优惠券</el-checkbox>
        <el-checkbox label="3">会员折扣</el-checkbox>
        <el-checkbox label="4">满减/随机减</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="bottom">
      <div>
        提示: 1.线下消费仅限电脑端和手机端商家的业务操作，非会员自助操作;
      </div>
      <div style="text-indent: 30px">
        2.线下消费包含快速消费、消费收银和增加计次业务。
      </div>
    </div>
    <div class="sublime">
      保存
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      offline_buy: []
    };
  },
  mounted() {},
  methods: {
    add() {
      if (this.offline_buy.length == 1) {
        this.$message("只能是两个以上进行互斥请重新选择");
        return;
      }
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      data.offline_buy = this.offline_buy.join(",");

      // jiekou
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  background: rgba(240, 242, 245, 1);
  font-size: 14px;
  .top {
    width: 100%;
    height: 118px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    padding: 0 24px;
    .top-title {
      height: 50%;
      border-bottom: 1px dashed #eee;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.75);
      .color {
        font-size: 13px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
      }
    }
    .el-checkbox-group {
      height: 50%;
    }
  }
  .bottom {
    margin: 18px 0 20px 0;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    > div {
      line-height: 20px;
    }
  }
  .sublime {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    background: rgba(47, 84, 235, 1);
    border-radius: 4px;
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
}
.color-red {
  color: red;
  padding-right: 10px;
}
.color-blue {
  color: #409eff;
}
</style>
